module.exports = __webpack_public_path__ + "img/0-52.8d26264d.jpg";